
    import * as React from 'react';

    const Pause60 = ({ color = 'currentcolor', height = '60px', width = '60px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 60 60" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Pause_60_svg__Icons/Pause/Black-60" stroke="none" strokeWidth={1} fillRule="evenodd"><g id="Pause_60_svg__Icons/Play/Black-60" fillRule="nonzero"><path d="M30,0 C46.5682896,0 60,13.4316094 60,29.9997743 C60,46.5683906 46.5682896,60 30,60 C13.4312589,60 0,46.5683906 0,29.9997743 C0,13.4316094 13.4312589,0 30,0 Z M30,1 C13.9837003,1 1,13.9837375 1,29.9997743 C1,46.016195 13.9836328,59 30,59 C46.016074,59 59,46.0160367 59,29.9997743 C59,13.9838958 46.0160065,1 30,1 Z M24,20 L24,41 L23,41 L23,20 L24,20 Z M37,20 L37,41 L36,41 L36,20 L37,20 Z" id="Pause_60_svg__Combined-Shape" /></g></g></svg>
        </div>
      );
    };

    Pause60.displayName = 'Pause60';

    export default Pause60;
  